<template id="modal-show-detail">
  <v-dialog :value="true" max-width="450" persistent @click:outside="hideModal">
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chọn phiếu thu/đơn đối soát
          <v-divider />
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Mã phiếu thu/đơn hàng<span style="color: red"> *</span>
            </v-col>
            <v-col cols="12" md="4" >
              <v-text-field
                  v-model="selectedRecord.code"
                  :disabled="isShowDetail"
                  outlined
                  placeholder="Nhập"
                  style="min-height: 15px !important;"
                  height="15"
                  id="hoc"
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" style="padding-left: 0px !important;"><v-btn style="text-transform: unset !important;" width="95px" color="#1890FF" @click="selectOrder(false)">Chọn</v-btn></v-col>

          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Tên khách hàng
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  :background-color="selectedRecord.receiver ? '' : '#EEEEEE'"
                  v-model="selectedRecord.receiver"
                  :disabled="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Số điện thoại
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  :background-color="selectedRecord.phone ? '' : '#EEEEEE'"
                  v-model="selectedRecord.phone"
                  :disabled="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Giá trị
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  :background-color="selectedRecord.totalPriceShow ? '' : '#EEEEEE'"
                  v-model="selectedRecord.totalPriceShow"
                  :disabled="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Người phụ trách
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  :background-color="selectedRecord.userFullName ? '' : '#EEEEEE'"
                  v-model="selectedRecord.userFullName"
                  :disabled="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-5 label-align">
              Hình thức
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  :background-color="selectedRecord.paymentType ? '' : '#EEEEEE'"
                  v-model="selectedRecord.paymentType"
                  :disabled="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="min-height: 50px;height: auto;">
            <v-col cols="12" md="4" class="pt-5 label-align">
              Gói sản phẩm
            </v-col>
            <v-col cols="12" md="7">
              <div class="product-pack" :style="selectedRecord.products.length > 0 || selectedRecord.combos.length > 0 ? '' : 'background-color: #EEEEEE'">
                <p v-for="(product, index) in selectedRecord.products" class="product-title" :key="index">{{ product.name }}</p>
                <span v-if="selectedRecord.combos && selectedRecord.combos.length > 0">
                  <span v-for="(combo, index2) in selectedRecord.combos" :key="`${index} + ${index2}`">
                    <span v-if="combo && combo.products && combo.products.length > 0">
                      <p v-for="(productInCombo, index3) in combo.products" class="product-title" :key="`${index} + ${index2} + ${index3}`">{{ productInCombo.name }}</p>
                    </span>
                  </span>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="group-btn-action">
          <v-btn color="#D9D9D9" style="color: black;text-transform: unset !important;" @click="hideModal" height="40px">Hủy</v-btn>
          <v-btn v-if="selectedRecord.transactionStatus !== trangThaiDaDoiXoat" color="#D83410" @click.prevent="handleSubmit(saveChange)" style="text-transform: unset !important;" height="40px">Xác nhận</v-btn>
          <v-btn v-if="selectedRecord.transactionStatus === trangThaiDaDoiXoat" color="#F2BD00" @click.prevent="handleSubmit(saveChangeTransactionApproved)" style="text-transform: unset !important;" height="40px">Đối soát lại</v-btn>
        </div>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const OrderRepository = RepositoryFactory.get('order')
import { KHONG_XAC_DINH } from "@/helpers/constants";
export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    selectedRecord: {
      default: () => ({})
    },
    filterForm: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      userId: '',
      isShowDetail: false,
      trangThaiDaDoiXoat: 2,
      invalidOrderStatus: ['T5','C5','T2','C2'],
      KHONG_XAC_DINH,
      receiptId: null,
    };
  },
  created() {
    if (this.selectedRecord.code) {
      this.selectOrder(true);
    }
  },
  methods: {
    // async selectOrder() {
    //   if(!this.selectedRecord.code){
    //     this.$swal({
    //       title: 'Chưa nhập mã đơn hàng.'
    //     })
    //     return
    //   }
    //   const res = await OrderRepository.getOrderDetailByCode(this.selectedRecord.code)
    //   if (this.selectedRecord.transactionStatus === KHONG_XAC_DINH) {
    //     if(this.invalidOrderStatus.includes(res?.data?.data[0]?.contactStatus?.type)){
    //       this.selectedRecord.code = this.selectedRecord.originOrderCode
    //       this.$swal({
    //         title: 'Trạng thái đơn hàng đã thành công hoặc huỷ vui lòng chọn đơn khác !!!',
    //       })
    //       return
    //     }
    //   }
    //   if (this.selectedRecord.transactionStatus !== KHONG_XAC_DINH) {
    //     if(['T2','C2'].includes(res?.data?.data[0]?.contactStatus?.type)){
    //       this.selectedRecord.code = this.selectedRecord.originOrderCode
    //       this.$swal({
    //         title: 'Trạng thái đơn hàng đã huỷ vui lòng chọn đơn khác !!!',
    //       })
    //       return
    //     }
    //   }
    //   if(res?.data?.data?.length > 0){
    //     let totalPriceShow = res.data.data[0].totalPrice.toLocaleString('it-IT', {style : 'currency', currency : 'VND'});
    //     this.selectedRecord.receiver = res.data.data[0].receiver; // Tên khách hàng
    //     this.selectedRecord.phone = res.data.data[0].phone; // Số điện thoại
    //     this.selectedRecord.totalPrice = res.data.data[0].totalPrice;
    //     this.selectedRecord.totalPriceShow = totalPriceShow; // Giá trị phiếu thu
    //     this.selectedRecord.userFullName = res.data.data[0].user.fullName; // Người phụ trách
    //     this.selectedRecord.orderId = res.data.data[0].id; // 
    //     this.selectedRecord.paymentType = res.data.data[0].paymentType; // Hình thức
    //     this.selectedRecord.products = res.data.data[0].products; // Gói sản phẩm
    //     this.selectedRecord.combos = res.data.data[0].combos;
    //     this.selectedRecord.originOrderCode = this.selectedRecord.code;
    //   }else{
    //     this.selectedRecord.code = this.selectedRecord.originOrderCode
    //     this.$swal({
    //       title: 'Đơn hàng không tồn tại !!!',
    //     })
    //   }
    // },
    async selectOrder(code = false) {
      if(!this.selectedRecord.code){
        this.$swal({
          title: 'Chưa nhập mã'
        })
        return
      }
      const res = await OrderRepository.getForReconcile(this.selectedRecord.code)
      // if (res.data && res.data.receipt && !code && ['final_success', 'final_cancel'].includes(res.data.receipt.status)) {
      //   return this.$swal({
      //     title: 'Trạng thái phiếu thu/ đơn hàng đã thành công hoặc hủy. Vui lòng chọn phiếu thu/ đơn hàng khác !',
      //   })
      // }
      if(res.data){
        this.selectedRecord.receiver = res.data.order.receiver; // Tên khách hàng
        this.selectedRecord.phone = res.data.order.phone; // Số điện thoại
        this.selectedRecord.totalPriceShow = res.data.receipt.amount.toLocaleString('it-IT', {style : 'currency', currency : 'VND'});; // Giá trị phiếu thu
        this.selectedRecord.userFullName = res.data.user.fullName; // Người phụ trách
        this.selectedRecord.paymentType = res.data.receipt.payment_method; // Hình thức
        this.selectedRecord.products = res.data.order.products; // Gói sản phẩm
        // this.selectedRecord.combos = res.data.data[0].combos;
        this.selectedRecord.originOrderCode = this.selectedRecord.code;
        this.receiptId = res.data.receipt.id;
      }else{
        this.$swal({
          title: res?.errors?.showMessage || 'Phiếu thu/ đơn hàng không tồn tại!',
        })
      }
    },
    hideModal: function() {
      this.$emit('close-modal')
      this.errorMessage = '';
    },
    async saveChangeTransactionApproved() {
      if (this.selectedRecord.code !== this.selectedRecord.originOrderCode){
        this.$swal({
          text: 'Vui lòng ấn chọn'
        });
        return
      }
      let body = {
        code: this.selectedRecord.orderId,
        transactionId: this.selectedRecord.transactionId,
      }
      const res = await OrderRepository.linkOrderWithTransactionApproved(body);
      if(res?.success){
        this.$swal({
          type: 'success',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
          title: 'Thao tác thành công !!!',
        })
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
      }else{
        this.$swal({
          type: 'error',
          title: res?.errors?.showMessage,
        });
      }
    },
    async saveChange() {
      if (!this.selectedRecord.code){
        return this.$swal({
          text: 'Chưa nhập mã phiếu thu/ đơn hàng'
        });
        
      }
      if (this.selectedRecord.code !== this.selectedRecord.originOrderCode){
        return this.$swal({
          text: 'Vui lòng ấn chọn'
        });
      }
      let body = {
        code: this.selectedRecord.code,
        transactionId: this.selectedRecord.transactionId,
      }
      const res = await OrderRepository.checkingReceipt(body);
     if(res?.success){
       this.$swal({
         type: 'success',
         icon: 'success',
         timer: 2000,
         showConfirmButton: false,
         title: 'Thao tác thành công !!!',
       })
       this.hideModal();
       Bus.$emit('contact-list-filter', this.filterForm);
     }else{
       this.$swal({
         type: 'error',
         title: res?.errors?.showMessage,
       });
     }
    }
  }
};
</script>


<style scoped>
.row{
  height: 50px;
}
.group-btn-action{
  display: flex;
  justify-content: end;
  padding-bottom: 15px;
}
.label-align{
  text-align: start;
}
.product-pack{
  border: 1px #bdbdbd solid;
  border-radius: 3px;
  padding-top: 15px;
  padding-left: 6px;
  min-height: 42px;
}
.product-pack .product-title{
  text-align: start;
  font-size: 14px !important;
  color: #bab9b9;
}
</style>
